import React, { useMemo } from 'react';
import { Box } from '@mui/joy';
import { KPI, Scorecard } from 'src/mtska-frontend-app-component';
import List from './List';

const Default = () => {
    const date = new Date();
    const formattedDateToday = date.toISOString().split('T')[0];
    const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const formattedDateStartOfMonth = `${startOfMonth.getFullYear()}/${String(startOfMonth.getMonth() + 1).padStart(2, '0')}/${String(startOfMonth.getDate()).padStart(2, '0')}`;
    
    return <>
        {/* <Box className="mtska-chart-wrapper">
            <KPI
                title="BlackListLeads"
                icon="faPeople"
                dataProviderName={'statistics/item/count/campaigns/blackListLead'}
            />
            <KPI
                title={"BlackListLeads current month (" + formattedDateStartOfMonth +")"}
                icon="faCalendar"
                dataProviderName={'statistics/currentmonth/count/campaigns/blackListLead'}
                filters={{
                    'items': [{
                        'field': 'registered_at',
                        'operator': 'afterOrEqual',
                        'value': formattedDateStartOfMonth
                    }]
                }}
            />
            <KPI
                title={"BlackListLeads today"}
                icon="faCalendarStar"
                dataProviderName={'statistics/currentday/count/campaigns/blackListLead'}
                filters={{
                    'items': [{
                        'field': 'registered_at',
                        'operator': 'afterOrEqual',
                        'value': formattedDateToday
                    }]
                }}
            />
        </Box> */}
        <List />
    </>

}

export default Default;


